module.exports = __webpack_public_path__ + "static/3_2_BayesRule_1_NO-c70cccd212950a5bb91edc7019d00e6b.svg";